import React from 'react'

import { Link } from 'gatsby'

import SocialMedia from '@components/Content/SocialMedia/SocialMedia'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'
import FooterMenu from '@components/Footer/FooterMenu'
import Container from '@components/Layout/Container'

import { useThemeSettings } from '@hooks/useThemeSettings'

import * as styles from './Footer.module.scss'
import FooterLinksMenu from './FooterLinksMenu'

function getCurrentDate() {
	const d = new Date()

	return `${d.getFullYear()}`
}

const Footer: React.FunctionComponent = () => {
	const themeSettings = useThemeSettings()

	return (
		<footer className={styles.footer}>
			<Container className={styles.container}>
				<div className={styles.content}>
					<div className={styles.logo}>
						<Link to="/">
							<img src="/logo-dark.png" alt="Versaclimber" loading={'lazy'} width={274} height={40} />
						</Link>
					</div>

					{themeSettings.companyLine ? (
						<Wysiwyg data={themeSettings.companyLine} className={styles.companyLine} />
					) : null}

					<ul className={styles.phoneNumbers}>
						<li>
							Sales:{' '}
							<a href={'tel:' + themeSettings.salesNumber.replace(' ', '')}>
								{themeSettings.salesNumber}
							</a>
						</li>
						<li>
							Service & Spares:{' '}
							<a href={'tel:' + themeSettings.serviceNumber.replace(' ', '')}>
								{themeSettings.serviceNumber}
							</a>
						</li>
					</ul>

					<SocialMedia />
				</div>

				<div className={styles.menuContainer}>
					<FooterMenu />

					<FooterLinksMenu />

					<span className={styles.copyright}>
						&copy; Copyright {getCurrentDate()} Versaclimber. Design by{' '}
						<a href="https://warboxcreative.co.uk/" target="_blank">
							Warbox
						</a>
					</span>
				</div>
			</Container>
		</footer>
	)
}

export default Footer
